/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import WebDrawer from '../web-drawer'
import DeliveryOptions from '../../pages/product-detail/partials/delivery-options'

const ShippingPickupModal = ({isOpen, onClose, deliveryOptionsData, cmsDeliverySectionBlock}) => {
    const {formatMessage} = useIntl()

    const title = cmsDeliverySectionBlock?.Title
        ? cmsDeliverySectionBlock.Title
        : formatMessage({
              defaultMessage: 'Shipping & Pickup Options',
              id: 'product_detail.accordion.button.shipping_and_pickup_options'
          })

    return (
        <WebDrawer
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            titleTextStyle="webH3"
            size="85vh"
        >
            <DeliveryOptions
                shippingMethodsData={deliveryOptionsData}
                cmsDeliverySectionBlock={cmsDeliverySectionBlock}
                disableShowMore={true}
            />
        </WebDrawer>
    )
}

ShippingPickupModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    deliveryOptionsData: PropTypes.object,
    cmsDeliverySectionBlock: PropTypes.object
}

export default ShippingPickupModal
